import { isAdServerEnabled } from 'shared/utils/adServerUtils'
import {
  type CrossSellWidgetType,
  getIsBuyTogetherWidget,
} from 'shared/utils/crosssell'
import { type Experiment } from 'types/shopConfig'

export const isRetailMediaAdServerEnabled = ({
  widgets,
  experiments,
  wid,
  adServerCrossSellWidgetIds,
}: {
  widgets: CrossSellWidgetType
  experiments: Experiment[]
  wid: string
  adServerCrossSellWidgetIds: number[]
}): boolean => {
  const isBuyTogetherWidget = getIsBuyTogetherWidget(Number(wid), widgets)

  // Field defined on BuyTogether x-sell to determine the type of x-sell.
  // We don't want any Ad-server changes happening in BuyTogethers atm.
  return (
    !isBuyTogetherWidget &&
    isAdServerEnabled(experiments) &&
    // Fetch the widget from ad-server api only for specific wid
    adServerCrossSellWidgetIds.includes(Number(wid))
  )
}
